
import { MessageBox } from 'element-ui';
import { Message } from 'element-ui';
import { Loading } from 'element-ui';

import { pinyin } from 'js/pyconst.js';
export const BzMsg = {
    loadingInstance: {
        close() {

        }
    },
    ShowMsg: function (msg, callback) {
        MessageBox.alert(msg, '消息提示', {
            confirmButtonText: '确定',
            callback: callback
        });
        // Message.success({
        //     showClose: true,
        //     message: msg,
        //     type: 'success'
        // });
    },
    ShowToast: function (msg) {
        Message.success({
            message: msg,
            type: 'success', customClass: 'zZindex',
            showClose: true,
        });
    },
    ShowErr: function (msg, callback) {
        Message.error({
            message: msg,
            type: 'error',
            duration: 10000,
            showClose: true,
            customClass: 'zZindex',
        });
    },
    ShowAsk: function (msg, callback) {
        MessageBox.confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(() => {
                callback()
            })
            .catch(() => {

            });

    },
    ShowAskE: function (msg) {
        return new Promise((resolve, reject) => {
            MessageBox.confirm(msg, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                dangerouslyUseHTMLString: true,
                closeOnPressEscape: true,
                type: "warning"
            })
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        })

    },
    InputBox: function (options, callback) {


    },
    Loading: function (n, t) {
        if (n == true) {
            t == undefined ? "正在为您拼命加载。。。" : t
            this.loadingInstance = Loading.service({
                lock: true,
                text: t,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        } else {
            this.loadingInstance.close();
        }

    }
};
export const BzUser = {
    get: function () {
        var users = JSON.parse(localStorage.getItem("localuser"));
        if (users == null) {
            users = {};
            users.IsLogin = 0;

            users.ExpiryDate = BzDate.format(new Date(), "yyyy-MM-dd hh:mm:ss")
        }
        if (BzDate.addHours(users.ExpiryDate, 2).getTime() < new Date().getTime()) {
            localStorage.removeItem("localuser");
            users.IsLogin = 0;
        } else {
            users.ExpiryDate = new Date();
            BzUser.setuser(users);
        }
        return users;
    },
    setuser: function (users) {
        localStorage.setItem("localuser", JSON.stringify(users))
    },
    deleteuser: function () {
        localStorage.removeItem("localuser");
    }
};
export const BzlocalStorage = {
    get: function (name, time) {
        var users = JSON.parse(localStorage.getItem(name));
        if (users == null) {
            users = {};
            users.IsEffective = 0;
            users.ExpiryDate = BzDate.format(new Date(), "yyyy-MM-dd hh:mm:ss")
        }
        if (BzDate.addHours(users.ExpiryDate, time).getTime() < new Date().getTime()) {
            localStorage.removeItem(name);
            users.IsEffective = 0;
        } else {
            users.ExpiryDate = new Date();
            localStorage.setItem(name, JSON.stringify(users))

        }
        return users;
    },
    set: function (name, obj) {
        obj.ExpiryDate = BzDate.format(new Date(), "yyyy-MM-dd hh:mm:ss");
        obj.IsEffective = 1;
        localStorage.setItem(name, JSON.stringify(obj))
    },
    deleteuser: function (name) {
        localStorage.removeItem(name);
    }
};
export const BzStore = {
    get: function (name, defaultvalue) {
        let value = localStorage.getItem(name);
        if (value) {
            return value;
        } else {
            return defaultvalue;
        }
    },
    getJSON: function (name, defaultvalue) {
        let value = localStorage.getItem(name);
        if (value) {
            return JSON.parse(value);
        } else {
            return defaultvalue;
        }
    },
    getWithTime: function (name, time) {
        var users = JSON.parse(localStorage.getItem(name));
        if (users == null) {
            users = {};
            users.IsEffective = 0;
            users.ExpiryDate = BzDate.format(new Date(), "yyyy-MM-dd hh:mm:ss")
        }
        if (BzDate.addHours(users.ExpiryDate, time).getTime() < new Date().getTime()) {
            localStorage.removeItem(name);
            users.IsEffective = 0;
        } else {
            users.ExpiryDate = new Date();
            localStorage.setItem(name, JSON.stringify(users))

        }
        return users;
    },
    set: function (name, value) {
        localStorage.setItem(name, value)
    },
    setWithTime: function (name, obj) {
        obj.ExpiryDate = BzDate.format(new Date(), "yyyy-MM-dd hh:mm:ss");
        obj.IsEffective = 1;
        localStorage.setItem(name, JSON.stringify(obj))
    },
    setJSON: function (name, value) {
        localStorage.setItem(name, JSON.stringify(value))
    },
    delete: function (name) {
        localStorage.removeItem(name);
    }
};
export const BzDate = {
    format(formatdate, fmt) { //author: meizz 
        if (!(formatdate instanceof Date)) {
            formatdate = new Date(formatdate)
        }
        var o = {
            "M+": formatdate.getMonth() + 1, //月份 
            "d+": formatdate.getDate(), //日 
            "h+": formatdate.getHours(), //小时 
            "m+": formatdate.getMinutes(), //分 
            "s+": formatdate.getSeconds(), //秒 
            "q+": Math.floor((formatdate.getMonth() + 3) / 3), //季度 
            "S": formatdate.getMilliseconds() //毫秒 
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (formatdate.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));

        return fmt;
    },
    //获取两个时间之间的间隔
    getTimeDiff(dateBegin, dateEnd, timetype) {
        var dateBegin = new Date(dateBegin);
        var dateEnd = new Date(dateEnd);
        var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
        switch (timetype) {
            case 1:
                return Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
            case 2:
                return Math.floor(leave1 / (3600 * 1000));//计算出小时数
            case 3:
                return Math.floor(leave2 / (60 * 1000));//计算相差分钟数
            case 4:
                return Math.round(leave3 / 1000);//计算毫秒数
        }
    },
    //判断第一个是不是比第二个大
    checkDate: function (Date1, Date2) {
        var oDate1 = new Date(Date1);
        var oDate2 = new Date(Date2);
        if (oDate1.getTime() > oDate2.getTime()) {
            return true;
        } else {
            return false;
        }
    },
    addMonth: function (pdate, n) {   // n个月后 
        var mydate = new Date(pdate);
        //当前月
        var m = mydate.getMonth() + 1;
        var y = mydate.getFullYear();
        var retdate = mydate.getTime();
        for (var i = 0; i < n + 1; i++) {
            retdate += BzDate.getMonthDay(y, m) * 86400000
            m++;
            if (m == 13) {
                y++;
                m = 1;
            }
        }

        return new Date(retdate);
    },
    getMonthDay: function (year, month) {
        if (month == 2) {
            if (year % 4 == 0 && year % 100 != 0)
                return 29;
            else
                return 28;
        }
        else if ((month <= 7 && month % 2 == 1) || (month > 7 && month % 2 == 0))
            return 31;
        else
            return 30;
    },
    addHours: function (date1, hours) {
        var mydate = new Date(date1);
        var time = mydate.getTime() + 1000 * 60 * 60 * hours;
        return new Date(time);
    }
};
export const BzJs = {
    replaceAll(str, oldstr, newstr) {
        return str.replace(new RegExp(oldstr, "gm"), newstr);
    },
    splitNumber(arrlength, number) {
        number = number.toString();

        var newarr = [];
        if (number.length < arrlength) {
            for (var i = number.length; i < arrlength; i++) {
                newarr.push(0);
            }
        }
        for (var i = 0; i < number.length; i++) {
            newarr.push(number.substr(i, 1))
        }

        return newarr;
    },
    guid() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    },
    exportExcel(url) {
        const loadingInstance = Loading.service({
            lock: true,
            text: '正在为您导出，请耐心等待。。。',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        let iframe = document.createElement("iframe");
        iframe.src = url;

        iframe.style.display = "none";
        if (iframe.attachEvent) {
            iframe.attachEvent("onload", d => {

                loadingInstance.close();
            });
        } else {
            iframe.onload = function () {

                loadingInstance.close();
            };
        }
        document.body.appendChild(iframe);
        setTimeout(() => {
            loadingInstance.close();
        }, 1000);
    }
}
export const ElementConfig = {
    SystemDateOptions: {
        shortcuts: [
            {
                text: "最近一周",
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                }
            },
            {
                text: "最近一个月",
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", [start, end]);
                }
            },
            {
                text: "最近三个月",
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit("pick", [start, end]);
                }
            }
        ]

    }
}
export const BzPinYin = {
    chineseToFirstPinYin: function (l1) {
        var l2 = l1.length;
        var I1 = '';
        var reg = new RegExp('[a-zA-Z0-9]');
        for (var i = 0; i < l2; i++) {
            var val = l1.substr(i, 1);
            var name = this.arraySearch(val);
            if (reg.test(val)) {
                I1 += val.substr(0, 1);
            } else if (name !== false) {
                I1 += name.substr(0, 1);
            }
        }
        I1 = I1.replace(/ /g, '-');
        while (I1.indexOf('--') > 0) {
            I1 = I1.replace('--', '-');
        }
        return I1;
    },
    chineseToPinYin: function (l1) {
        var l2 = l1.length;
        var I1 = '';
        var reg = new RegExp('[a-zA-Z0-9]');
        for (var i = 0; i < l2; i++) {
            var val = l1.substr(i, 1);
            var name = this.arraySearch(val, pinyin);
            if (reg.test(val)) {
                I1 += val;
            } else if (name !== false) {
                I1 += name;
            }
        }
        I1 = I1.replace(/ /g, '-');
        while (I1.indexOf('--') > 0) {
            I1 = I1.replace('--', '-');
        }
        return I1;
    },
    arraySearch: function (l1) {
        for (var name in pinyin) {
            if (pinyin[name].indexOf(l1) !== -1) {
                return this.ucfirst(name);
            }
        }
        return false;
    },
    ucfirst: function (l1) {
        if (l1.length > 0) {
            var first = l1.substr(0, 1).toUpperCase();
            var spare = l1.substr(1, l1.length);
            return first + spare;
        }
    }
};


// WEBPACK FOOTER //
// ./src/assets/script/helper.js